import React from "react";

// Mock data for the report to make the component dynamic
const matchingData = {
  girl: {
    name: "Meera Kapoor",
    date: "10th Jan 1998",
    place: "Delhi",
    time: "10:00 AM",
    mangalDosha: false,
  },
  boy: {
    name: "Arjun Malhotra",
    date: "10th Jan 1998",
    place: "Delhi",
    time: "10:00 AM",
    mangalDosha: true,
  },
  score: 24,
  maxScore: 36,
  compatibilityText:
    "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
};

// Reusable component for displaying person details (Girl/Boy)
const PersonDetails = ({ type, data }) => (
  <div className="mb-6 last:mb-0">
    <h2 className="web-body-md text-primary-500 mb-3">
      {type === "girl" ? "Girl Details" : "Boy Details"}
    </h2>
    <div className="flex flex-wrap text-sm text-gray-700">
      <div className="w-full sm:w-1/3 mb-2 sm:mb-0">
        <span className="web-h5">
          {type === "girl" ? data.name : data.name}
        </span>
      </div>
    </div>
    <div className="flex flex-wrap text-sm text-gray-700 mt-2">
      <div className="w-full sm:w-1/3 web-body-md">
        Date of Birth: <span className="web-body-md">{data.date}</span>
      </div>
      <div className="w-full sm:w-1/3 web-body-md">
        Place of Birth: <span className="web-body-md">{data.place}</span>
      </div>
      <div className="w-full sm:w-1/3 web-body-md">
        Time of Birth: <span className="web-body-md">{data.time}</span>
      </div>
    </div>
  </div>
);

// Reusable component for compatibility sections
const CompatibilitySection = ({ title, text }) => (
  <div className="mb-4">
    <h3 className="web-h6 text-gray-950 mb-3">{title}</h3>
    <p className="web-body-md text-gray-600 !leading-relaxed">{text}</p>
  </div>
);

function KundliMatchingDetail() {
  const { girl, boy, score, maxScore, compatibilityText } = matchingData;
  const compatibilityCategories = [
    "Mental",
    "Physical",
    "Financial",
    "Emotional",
  ];

  const totalDosha = girl.mangalDosha || boy.mangalDosha ? "Yes" : "No";

  return (
    <>
      <section className="notifications-bg py-8 md:py-12 bg-white min-h-screen">
        <div className="container">
          {/* Header and Action Buttons */}
          <div className="flex justify-between flex-wrap gap-[10px] items-center mb-6 md:mb-8">
            <h1 className="web-h3 text-gray-950">Kundli Matching</h1>
            <div className="flex space-x-3">
              <button className="custom-btn custom-btn-secondary">
                Save Report
              </button>
              <button className="custom-btn custom-btn-primary">
                Consult Expert
              </button>
            </div>
          </div>

          {/* Main Content: Two Columns */}
          <div className="flex flex-col lg:flex-row gap-6">
            {/* --- LEFT COLUMN: Report Details --- */}
            <div className="lg:w-3/4 bg-white p-[15px] md:p-[20px] rounded-[20px] border border-gray-100">
              <div className="p-[15px] bg-gray-50 rounded-[10px]">
                <PersonDetails type="girl" data={girl} />
                <PersonDetails type="boy" data={boy} />
              </div> 

              <h2 className="web-h5 text-gray-950 mb-6 mt-4">
                Compatibility
              </h2>
              
              {compatibilityCategories.map((category) => (
                <CompatibilitySection
                  key={category}
                  title={category}
                  text={compatibilityText}
                />
              ))}

              {/* Suggestions & Remedies Section */}
              <div className="mt-8">
                <h3 className="web-h6 text-gray-950 font-semibold mb-3">
                  Suggestions & Remedies
                </h3>
                <p className="body-md text-gray-600">{compatibilityText}</p>
              </div>
            </div>

            {/* --- RIGHT COLUMN: Profile Card (Fixed Width) --- */}
            <div className="lg:w-1/4 flex-shrink-0">
              <div className="text-center bg-primary-50 p-[15px] md:p-[20px] rounded-[20px]">
                <div className="bg-white border border-gray-100 rounded-[10px] p-[10px] flex flex-col gap-[15px]">
                  <div className="flex flex-col gap-[5px]">
                    <h3 className="web-h3 text-gray-950">24</h3>
                    <p className="web-body-md text-gray-950">out of 36</p>
                    <button className="web-body-md bg-[#020079] text-[14px] medium text-white w-[fit-content] mx-auto px-[15px] p-[5px] rounded-[10px] mt-[5px]">Good Match</button>
                  </div>
                </div>

                {/* Lucky Details */}
                <div className="space-y-4 pt-4 border-t border-gray-100">
                  <div className="flex items-center justify-between text-base flex-col gap-[5px]">
                    <h5 className="web-h5 text-gray-950">Mangal Dosha</h5>
                    <span className="web-h5 text-green-600">Yes</span>
                  </div>

                  <div className="flex items-center justify-between text-base flex-col gap-[2px]">
                    <span className="web-body-md text-gray-950">Meera Kapoor</span>
                    <span className="web-h5 text-red-600">No</span>
                  </div>

                  <div className="flex items-center justify-between text-base flex-col gap-[2px]">
                    <span className="web-body-md text-gray-950">Arjun Malhotra</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default KundliMatchingDetail;
